import React, { useEffect } from 'react';
import { formatAddress } from '../../../helper';
import EditProfileModals from '../../../shared/EditProfileModals';
import { useEditProfileFlow } from '../../../hooks/useEditProfileFlow';
import { useDispatch, useSelector } from 'react-redux';
import { useProfile } from '../../../hooks/useProfile';
import { useWalletAuth } from '../../landing/header/hooks/useWalletAuth';
import { openEditProfileModal } from '../../../Redux/store/modalSlice';
import useWallet from '../../../hooks/useWallet';
import { useTheme } from '../../../hooks/ThemeProvider';

function ProfileInfo() {

    const { logedIn } = useWalletAuth();
    const { address } = useWallet();
    const { userProfile, fetchUserProfile } = useProfile(logedIn);
    const dispatch = useDispatch();
    const { showSuccessModal } = useSelector(state => state.modal);
    const handleQuickEdit = () => {
        dispatch(openEditProfileModal());
    };
    useEffect(() => {
        if (showSuccessModal) {
            fetchUserProfile();
        }
    }, [showSuccessModal])
    const { theme } = useTheme();

    return (
        <>
            <div className="top_future">
                <div className="inner_top">
                    {userProfile.imageUrl && (
                        <img src={userProfile.imageUrl} className="imggdra" alt="profile" />
                    )}
                    <div>
                        {userProfile.name && <h4>{userProfile.name}</h4>}
                        <p>{formatAddress(address)}</p>
                    </div>
                </div>

                <div className="rightttside">
                    <button onClick={handleQuickEdit}>

                        {
                            theme === 'dark' ? <img src="\assets\editpro.svg" alt="edit" />
                                : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M6.70833 8.75H4.08333C3.46449 8.75 2.871 8.99583 2.43342 9.43342C1.99583 9.871 1.75 10.4645 1.75 11.0833V12.25" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.4706 9.69851C12.7029 9.46613 12.8335 9.15096 12.8335 8.82234C12.8335 8.49371 12.7029 8.17855 12.4706 7.94617C12.2382 7.7138 11.923 7.58325 11.5944 7.58325C11.2658 7.58325 10.9506 7.7138 10.7182 7.94617L8.37907 10.2865C8.24038 10.4251 8.13886 10.5965 8.0839 10.7847L7.59565 12.4588C7.58101 12.509 7.58013 12.5622 7.59311 12.6129C7.60609 12.6635 7.63244 12.7098 7.66941 12.7467C7.70638 12.7837 7.75261 12.8101 7.80326 12.823C7.85392 12.836 7.90712 12.8351 7.95732 12.8205L9.63148 12.3323C9.81971 12.2773 9.99104 12.1758 10.1297 12.0371L12.4706 9.69851Z" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M5.83333 6.41667C7.122 6.41667 8.16667 5.372 8.16667 4.08333C8.16667 2.79467 7.122 1.75 5.83333 1.75C4.54467 1.75 3.5 2.79467 3.5 4.08333C3.5 5.372 4.54467 6.41667 5.83333 6.41667Z" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                        }
                        Edit Profile
                    </button>

                    {/* Social links */}
                    {userProfile.twitter && (
                        <a href={userProfile.twitter} target="_blank" rel="noopener noreferrer">

                            <img src="\assets\x.svg" alt="twitter" />
                        </a>
                    )}
                    {userProfile.instagram && (
                        <a href={userProfile.instagram} target="_blank" rel="noopener noreferrer">
                            <img src="\assets\insta.svg" alt="instagram" />
                        </a>
                    )}
                    {userProfile.discord && (
                        <a
                            href={`https://discordapp.com/users/${encodeURIComponent(userProfile.discord)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src="\assets\dis.svg" alt="discord" />
                        </a>
                    )}
                </div>
            </div>

            {userProfile.description && <p>{userProfile.description}</p>}

            {/* Mobile socials */}
            <div className="formobileicone">
                <div className="inner d-none">
                    <div className="parentbuttonsss">
                        <button className="editmain" onClick={handleQuickEdit}>
                            {
                                theme === 'dark' ? <img src="\assets\editpro.svg" alt="edit" /> :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M6.70833 8.75H4.08333C3.46449 8.75 2.871 8.99583 2.43342 9.43342C1.99583 9.871 1.75 10.4645 1.75 11.0833V12.25" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M12.4706 9.69851C12.7029 9.46613 12.8335 9.15096 12.8335 8.82234C12.8335 8.49371 12.7029 8.17855 12.4706 7.94617C12.2382 7.7138 11.923 7.58325 11.5944 7.58325C11.2658 7.58325 10.9506 7.7138 10.7182 7.94617L8.37907 10.2865C8.24038 10.4251 8.13886 10.5965 8.0839 10.7847L7.59565 12.4588C7.58101 12.509 7.58013 12.5622 7.59311 12.6129C7.60609 12.6635 7.63244 12.7098 7.66941 12.7467C7.70638 12.7837 7.75261 12.8101 7.80326 12.823C7.85392 12.836 7.90712 12.8351 7.95732 12.8205L9.63148 12.3323C9.81971 12.2773 9.99104 12.1758 10.1297 12.0371L12.4706 9.69851Z" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.83333 6.41667C7.122 6.41667 8.16667 5.372 8.16667 4.08333C8.16667 2.79467 7.122 1.75 5.83333 1.75C4.54467 1.75 3.5 2.79467 3.5 4.08333C3.5 5.372 4.54467 6.41667 5.83333 6.41667Z" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                            }

                            Edit Profile
                        </button>

                        {userProfile.twitter && (
                            <a href={userProfile.twitter} target="_blank" rel="noopener noreferrer">
                                <img src="\assets\x.svg" alt="twitter" />
                            </a>
                        )}
                        {userProfile.instagram && (
                            <a href={userProfile.instagram} target="_blank" rel="noopener noreferrer">
                                <img src="\assets\insta.svg" alt="instagram" />
                            </a>
                        )}
                        {userProfile.discord && (
                            <a
                                href={`https://discordapp.com/users/${encodeURIComponent(userProfile.discord)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src="\assets\dis.svg" alt="discord" />
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProfileInfo;
